<script setup>
import { inject, onMounted } from 'vue';
import RegisterContainer from '@/components/Auth/RegisterContainer';
import axios from 'axios';
import { router } from '@inertiajs/vue3';
import { useToast } from 'vue-toastification';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

const toast = useToast();
const { locale } = storeToRefs(useUserStore());

const props = defineProps({
    errors: {
        type: Object,
        default: _ => ({})
    }
});

const user = {
    first_name: '',
    last_name: '',
    company_name: '',
    email: '',
    phone_number: '',
    password: '',
    password_confirmation: '',
    code: ''
};

const getError = selector => (props.errors[selector] || null);

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    user.code = urlParams.get('code');
});

const isLoading = inject('isLoading');
const register = async () => {
    if (!isLoading.value) {
        await axios.get('/sanctum/csrf-cookie');
        const payload = {
            ...user,
            locale: locale.value
        };
        axios.post('/register', payload)
            .then(({ data }) => {
                router.visit(data?.redirect || '/offers');
            }).catch(() => {
                console.error('Registration failed');
            });
    }
};

const disablePaste = (event) => {
    event.preventDefault();
    toast.clear();
    toast.error('Pasting is not allowed');
};
</script>
<template>
<RegisterContainer>
    <template #title>{{ $t('auth.register.sign_up') }}</template>
    <form @submit.prevent="register">
        <StyledInput
            v-model="user.first_name"
            type="text"
            name="first_name"
            :error-message="getError('first_name')"
            :placeholder="$t('label.first_name')"
            :label="$t('label.first_name')" />
        <StyledInput
            v-model="user.last_name"
            type="text"
            name="last_name"
            :error-message="getError('last_name')"
            :placeholder="$t('label.last_name')"
            :label="$t('label.last_name')" />
        <StyledInput
            v-model="user.company_name"
            type="text"
            name="company_name"
            :error-message="getError('company_name')"
            :placeholder="$t('label.company_name')"
            :label="$t('label.company_name')" />
        <StyledInput
            v-model="user.email"
            type="email"
            name="email"
            :error-message="getError('email')"
            :placeholder="$t('label.email')"
            :label="$t('label.email')" />
        <StyledMask
            v-model="user.phone_number"
            name="phone_number"
            :placeholder="$t('label.phone_number')"    
            :label="$t('label.phone_number')"
            mask="(###) ###-####"
            :unmask="true" />      
        <StyledPassword
            v-model="user.password"
            class="password"
            :error-message="getError('password')"
            name="password"
            placeholder="******************"
            :label="$t('label.password')"
            @paste="disablePaste" />
        <StyledPassword
            v-model="user.password_confirmation"
            class="password"
            :error-message="getError('password_confirmation')"
            name="password_confirmation"
            placeholder="******************"
            :label="$t('label.password_confirmation')"
            @paste="disablePaste" />
        <StyledButton
            type="submit"
            color="primary"
            class="mb-4 custom-tab-btn">
            {{ $t('auth.login.sign_up') }}
        </StyledButton>
    </form>
    <div class="flex justify-between items-center">
        <StyledButton
            variant="outlined"
            class="custom-tab-btn-outlined"
            @click="$inertia.visit('/login')">
            {{ $t('auth.login.sign_in') }}
        </StyledButton>
    </div>
</RegisterContainer>
</template>

<style scoped>
    .custom-tab-btn-outlined {
        color: #00594C !important;
    }

    .custom-tab-btn {
        background: #00594C !important;
    }
</style>
